export default "__VITE_ASSET__7$0TCclv__"